import { useRecoilCallback, useRecoilValue } from "recoil";
import {
  BaseGridInternalProperties,
  BaseGridProperties,
} from "../components/BaseGrid/BaseGridProperties";
import {
  BaseGridKeyNameMapAtom,
  BaseGridKeyNameMapProperty,
} from "../components/BaseGrid/BaseGridAtoms";
import { useGridInstance } from "../components/BaseGrid/Hooks/useGridInstance";

export const useGetTableDataForFilter = () => {
  const useTableDataFromInternalInstance = <
    K extends keyof BaseGridInternalProperties
  >(
    tableName: string,
    instanceAttibute: K,
    source: string
  ): BaseGridInternalProperties[K] => {
    const getMappedInstanceState = useRecoilCallback(
      ({ snapshot }) =>
        (tableName) => {
          const instance =
            (snapshot.getLoadable(BaseGridKeyNameMapAtom)
              .contents as BaseGridKeyNameMapProperty[]) ?? null;

          const keyNameMap =
            instance?.find((z) => z.name === tableName) ?? null;

          return {
            ...keyNameMap,
          };
        }
    );
    const { instanceInternalSelector } = useGridInstance(
      getMappedInstanceState(tableName).uiid ?? "",
      source
    );

    const result = useRecoilValue(
      instanceInternalSelector(instanceAttibute)
    ) as BaseGridInternalProperties[K];
    return result;
  };

  const useTableDataFromInstance = <K extends keyof BaseGridProperties>(
    tableName: string,
    instanceAttribute: K,
    source: string
  ): BaseGridProperties[K] => {
    const getMappedInstanceState = useRecoilCallback(
      ({ snapshot }) =>
        (tableName: string) => {
          const instance =
            (snapshot.getLoadable(BaseGridKeyNameMapAtom)
              .contents as BaseGridKeyNameMapProperty[]) ?? null;
          return instance?.find((z) => z.name === tableName) ?? null;
        }
    );

    const { instanceSelector } = useGridInstance(
      getMappedInstanceState(tableName)?.uiid ?? "",
      source
    );

    const result = useRecoilValue(
      instanceSelector(instanceAttribute)
    ) as BaseGridProperties[K];
    return result;
  };

  return {
    useTableDataFromInternalInstance,
    useTableDataFromInstance,
  };
};
